export class tPaymentModel {

    shopID: string;
    paymentID: string;
    paymentName: string;
    accCode: string;
    accName: string;
    unCount: string;

    specialPaymentType: number;
    extPaymentCode: string;

    remark1: string;
    remark2: string;
    remark3: string;
    remark4: string;
    remark5: string;
    remark6: string;


    inactive: string;
    lastModifyDatetime: Date;
    lastModifyUserID: string;


}

// export class PaymentMethod_Special_ehCard{
//     static ehCard: string ="ehCard";
// }


export class BillPay_PaymentMethod_Class{
    paymentID: string;
    paymentDesc: string;
    paymentAmount:number;

    bpItemType:string;

    bpPackDesc:string;
    bpPackDis:string;
    bpPackPatientID:string;
    specialPaymentType:number;

    constructor(paymentID: string,
        paymentDesc: string,
        paymentAmount: number,
        bpItemType: string,
        bpPackDesc: string,
        bpPackDis : string,
        bpPackPatientID: string,
        specialPaymentType: number,
    ){
        this.paymentID = paymentID;
        this.paymentDesc = paymentDesc;
        this.paymentAmount = paymentAmount;
        this.bpItemType = bpItemType;
        this.bpPackDesc = bpPackDesc;
        this.bpPackDis = bpPackDis;
        this.bpPackPatientID = bpPackPatientID;
        this.specialPaymentType = specialPaymentType;
    }

}


export class tPayment_InactiveModel{
    static ACTIVE = 'N';
    static INACTIVE = 'Y';

}
